
import Vue from "vue"
import Tag from '@/components/tag/index.vue'
import SVGIcon from "@/components/svgIcon/index.vue"
import { faCircle, faX } from "@fortawesome/free-solid-svg-icons"
import { mapGetters } from 'vuex'
import { Route } from 'vue-router'
import store from '@/store'
import router from '@/router'
export default Vue.extend({
	components: {
		Tag, SVGIcon
	},
	//    created(){
	// 	console.log(this.allTags,this.currentTag);

	//    },
	methods: {
		toCachedTag(item: Route) {
			// console.log(item);
			router.push(item)

		},
		closeTag(item: Route, e: Event) {
			// e.preventDefault()
			e.stopPropagation()
			store.dispatch("tagView/delete", item)
		}
	},
	computed: {
		header: () => faCircle,
		footer: () => faX,
		...mapGetters({
			allTags: "tagView/allTags",
			currentTag: "tagView/currentTag"
		})

	}
})

